export default "__VITE_ASSET__DBEp1bBi__"